import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Events} from "../../../../../framework/providers/events";
import {AppConfig} from "../../../../../core/conf/main";

@Component({
    selector: 'app-minicalendar',
    templateUrl: './minicalendar.component.html',
    styleUrls: ['./minicalendar.component.scss'],
})
export class MinicalendarComponent implements OnInit, OnDestroy {

    appConfig = AppConfig;
    dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wedensday', 'Thusday', 'Friday', 'Saturday'];

    @Input()
    monthDayDates;
    @Input()
    type;
    @Input()
    eventsBy;
    @Input()
    appEventDays = {};
    @Input()
    prefix;
    @Input()
    daysMark;

    @Input()
    currentDate;

    constructor(public events: Events) {
    }

    ngOnInit() {
        // this.events.subscribe('dateData' + this.prefix, (data) => {
        //     if (data['key'] == 'setCurrenDate') {
        //         this.currentDate = data['currentDate'];
        //     }
        // });
        console.log(this.monthDayDates);
    }

    chooseDay(newDate = null, getInDay = true, closeWindow = false, manualChoose = false) {
        this.events.publish('chooseDay' + this.prefix, {'newDate': newDate, 'type':this.type});
    }

    ngOnDestroy() {
        // this.events.unsubscribe('save' + this.prefix);
    }

    prev() {

    }

    next() {

    }
}
